import React from 'react';
interface SpecimenProps {
  title: string;
  note?: string;
  children: React.ReactNode;
}

/** A labelled component sample, grouped by hairline rather than a box. */
export function Specimen({
  title,
  note,
  children
}: SpecimenProps) {
  return <div className="border-t border-white/[0.07] pt-6 first:border-t-0 first:pt-0" data-id="element-1046" data-mp="7b22f09ydo3t">
      <h3 className="text-[15px] font-semibold text-ink" data-id="element-1047" data-mp="29325z9if7b3">{title}</h3>
      {note && <p className="mt-1 text-[14px] leading-snug text-ink-muted" data-id="element-1048" data-mp="g9dtt4in8pxb">{note}</p>}
      <div className="mt-4" data-id="element-1049" data-mp="c9de7gjt68oo">{children}</div>
    </div>;
}